import { Link } from 'react-router-dom';
import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import SEO from '@/components/base/SEO';
import MovieCard from '@/components/feature/MovieCard';
import { movies, categories, articles, faqs } from '@/mocks/movies';
import { getOrganizationSchema, getWebSiteSchema, getWebPageSchema, getFAQSchema, getBreadcrumbSchema } from '@/utils/schema';

export default function Home() {
  const hotMovies = movies.filter((m) => m.isHot);
  const newMovies = movies.filter((m) => m.isNew);
  const otherMovies = movies.filter((m) => !m.isHot && !m.isNew);
  const displayMovies = [...hotMovies, ...newMovies.slice(0, 2), ...otherMovies.slice(0, 4)];

  const categoryDisplay = categories.filter((c) => c.slug !== 'all');

  const pageTitle = '春色影视最新网址入口 - 高清影视免费在线观看不卡顿';
  const pageDesc = '春色影视最新网址入口与官网新地址发布，提供高清免费电影电视剧全集在线观看。春色影视平台不缓冲流畅播放，最新影视资源每日更新，涵盖电影、电视剧、综艺、动漫等全类型高清内容。';

  const webPageSchema = getWebPageSchema(
    pageTitle,
    pageDesc,
    'https://chunse.yingshi.com',
    getBreadcrumbSchema([{ name: '首页', url: 'https://chunse.yingshi.com' }]).itemListElement
  );

  return (
    <>
      <SEO
        title="最新网址入口 - 高清影视免费在线观看不卡顿"
        description={pageDesc}
        keywords="春色影视最新网址,春色影视入口,春色影视官网,春色影视新地址,色影视,影视平台访问,高清免费电影,电视剧全集在线,影视在线观看,免费高清不缓冲"
        canonicalUrl="https://chunse.yingshi.com"
        schema={{ ...getOrganizationSchema(), ...getWebSiteSchema(), ...webPageSchema }}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[500px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20red%20and%20gold%20ambient%20lighting%2C%20abstract%20film%20projector%20beam%20of%20light%20cutting%20through%20darkness%2C%20elegant%20theater%20curtain%20texture%2C%20dramatic%20shadow%20play%2C%20luxurious%20cinema%20aesthetic%2C%20no%20text%2C%20artistic%20composition&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
            alt="春色影视 - 高清影视免费在线观看"
            title="春色影视 - 高清影视免费在线观看平台"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-50"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60"></div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-fire-line text-primary-500 text-xs"></i>
              </span>
              <span className="text-xs text-primary-400 font-medium whitespace-nowrap">春色影视最新网址入口已更新</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-50 leading-tight mb-4">
              高清影视<span className="text-gradient-primary">免费在线观看</span>
            </h1>
            <p className="text-base md:text-lg text-foreground-300 max-w-2xl mx-auto mb-8 leading-relaxed">
              春色影视最新网址入口，提供海量高清电影、电视剧、综艺、动漫等全类型影视资源。每日更新最新内容，流畅播放不卡顿，随时随地畅享精彩影视世界。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/movie"
                className="flex items-center gap-2 px-7 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </span>
                立即观影
              </Link>
              <Link
                to="/about"
                className="flex items-center gap-2 px-7 py-3 rounded-lg bg-background-100/80 hover:bg-background-200/80 text-foreground-200 font-medium text-sm border border-background-300/50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-information-line"></i>
                </span>
                了解更多
              </Link>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 mt-10 text-xs text-foreground-500">
              <div className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-double-line text-accent-500"></i>
                </span>
                高清画质
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-double-line text-accent-500"></i>
                </span>
                流畅不卡顿
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-double-line text-accent-500"></i>
                </span>
                每日更新
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-double-line text-accent-500"></i>
                </span>
                完全免费
              </div>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
              <a href="#category-nav">分类导航</a>
            </h2>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              查看全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
            {categoryDisplay.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 hover:bg-background-200/70 card-hover cursor-pointer group border border-background-200/50"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors duration-200">
                  <span className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center">
                    <i className={`${cat.icon} text-xl md:text-2xl text-primary-500`}></i>
                  </span>
                </div>
                <span className="text-sm font-medium text-foreground-300 group-hover:text-foreground-100 transition-colors duration-200 whitespace-nowrap">
                  {cat.name}
                </span>
              </Link>
            ))}
          </div>
        </section>

        {/* Hot & Recommended */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
                <a href="#hot-recommend">热门推荐</a>
              </h2>
              <span className="px-2.5 py-0.5 rounded-full bg-accent-500/20 text-accent-500 text-xs font-medium whitespace-nowrap">
                每日精选
              </span>
            </div>
            <Link
              to="/category/movie"
              className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              更多推荐
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
            {hotMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </section>

        {/* Latest Updates */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
                <a href="#latest-updates">最新更新</a>
              </h2>
              <span className="px-2.5 py-0.5 rounded-full bg-primary-500/20 text-primary-500 text-xs font-medium whitespace-nowrap">
                实时更新
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
            {newMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </section>

        {/* All Content Grid */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-100 mb-6">
            <a href="#all-content">全部影视内容</a>
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {displayMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </section>

        {/* Latest Articles */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-100 mb-6">
            <a href="#latest-articles">影视资讯</a>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {articles.slice(0, 4).map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="flex gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200/70 card-hover cursor-pointer group border border-background-200/50"
              >
                <div className="w-40 h-28 shrink-0 rounded-md overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex flex-col justify-between min-w-0 py-0.5">
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{article.summary}</p>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-600">
                    <span>{article.date}</span>
                    <span>{article.author}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-100 mb-6 text-center">
            <a href="#faq">常见问题</a>
          </h2>

          <FAQSchema faqs={faqs} />

          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="group rounded-lg bg-background-100 border border-background-200/50 overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-200 hover:text-foreground-100 transition-colors duration-200 list-none">
                  {faq.q}
                  <span className="w-5 h-5 flex items-center justify-center shrink-0 ml-2">
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform duration-200"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function FAQSchema({ faqs }: { faqs: { q: string; a: string }[] }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(getFAQSchema(faqs)) }}
    />
  );
}